// "Push on this device" for Settings → Notifications.
// The browser (or the installed Home Screen app on iPhone) subscribes with the
// server's VAPID public key; the API stores it so New booking alerts reach it.

export function urlB64ToUint8Array(b64) {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

// What this browser can do. iPhone Safari only allows web push from the
// installed Home Screen app (iOS 16.4+), so we say that instead of failing.
export function pushSupport(env = (typeof window !== 'undefined' ? window : {})) {
  const nav = env.navigator || {};
  const ua = String(nav.userAgent || '');
  const ios = /iPhone|iPad|iPod/.test(ua);
  const standalone = !!(nav.standalone || (env.matchMedia && env.matchMedia('(display-mode: standalone)').matches));
  const has = !!(nav.serviceWorker && env.PushManager && env.Notification);
  if (has) return { ok: true, reason: '' };
  if (ios && !standalone) return { ok: false, reason: 'ios-install' };
  return { ok: false, reason: 'unsupported' };
}

export function supportMessage(reason) {
  if (reason === 'ios-install') return 'On iPhone, add Bricks to your Home Screen (Share, then Add to Home Screen), open it from there, and turn push on.';
  if (reason === 'denied') return 'Notifications are blocked for app.brxs.ca in this browser. Allow them in the browser settings, then try again.';
  if (reason === 'unsupported') return "This browser can't show push notifications. Try Chrome, Edge, Firefox or Safari.";
  return '';
}

async function registration() {
  const nav = window.navigator;
  const reg = (await nav.serviceWorker.getRegistration('/')) || (await nav.serviceWorker.register('/sw.js'));
  return nav.serviceWorker.ready.then(() => reg);
}

export async function currentSubscription() {
  if (!pushSupport().ok) return null;
  const reg = await registration();
  return reg.pushManager.getSubscription();
}

export async function enablePush(api) {
  const { data: cfg } = await api.get('/push/config');
  if (!cfg || !cfg.configured || !cfg.public_key) throw new Error("Push isn't set up on the server yet.");
  const perm = await window.Notification.requestPermission();
  if (perm !== 'granted') {
    const err = new Error(supportMessage('denied'));
    err.code = 'denied';
    throw err;
  }
  const reg = await registration();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8Array(cfg.public_key) });
  }
  await api.post('/push/subscribe', { subscription: sub.toJSON() });
  return sub;
}

export async function disablePush(api) {
  const sub = await currentSubscription();
  if (!sub) return;
  try { await api.post('/push/unsubscribe', { endpoint: sub.endpoint }); } finally { await sub.unsubscribe(); }
}
